module.exports = __webpack_public_path__ + "img/nex_img.dc5b869e.svg";